export default "__VITE_ASSET__5f974b37__"